jQuery( document ).ready( function( $ ) {
    // Smooth Scroll
    $('a[href*="#"]')
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function(event) {
            if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            &&
            location.hostname == this.hostname
            ) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                if (target.length) {
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - 133
                    }, 1000);
                }
            }
        });
    // End Smooth Scroll


    //FAQ's for the Resources Page Functionality - Accordian Dropdowns

        // Select all accordion toggles
        var acc = document.getElementsByClassName("accordion-toggle");
        var item = document.getElementsByClassName("accordion-item");
        var i;

        console.log(acc);

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function() {
                // Toggle the 'active' class on the accordion toggle
                this.classList.toggle("active");
                var item = this.parentNode;
                item.classList.toggle("active-item");

                // Find the next sibling element that is the content panel
                var panel = this.nextElementSibling;
                console.log(panel);

                // Check if the accordion content is already expanded
                if (panel.style.maxHeight) {
                    // If it is, collapse it
                    panel.style.maxHeight = null;
                } else {
                    // Otherwise, expand it to its scroll height
                    // This requires a slight modification: the content panel to expand/collapse is now a child of the clicked element's next sibling, not the sibling itself.
                    // We must ensure the 'accordion-content' is targeted specifically, especially if your structure includes other sibling elements that could interfere.
                    panel = this.parentNode.querySelector('.accordion-content'); // Adjusted to target the .accordion-content specifically within the parent item.
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }

    console.log("wg-main.js loaded");

    //End FAQ's for the Resources Page Functionality - Accordian Dropdowns
} );

document.addEventListener('DOMContentLoaded', () => {
    swiperSlider()
    imageCompareFn()
})

function imageCompareFn () {
    const element = document.querySelectorAll('.wg-before-after__image-compare')
    const options = {
        smoothing: false,
        addCircle: true
    }
    element.forEach((element) => {
        // eslint-disable-next-line no-undef
        new ImageCompare(element, options).mount()
      })
}

function swiperSlider () {
    const testimonialsSliderContainer = document.querySelectorAll('.wg-testimonials .swiper')
    const beforeAfterContainer = document.querySelectorAll('.wg-before-after .swiper')

    beforeAfterContainer.forEach(element => {
      const swipperId = `#${element.getAttribute('id')}`
      const swiperElement = document.querySelector(swipperId)
      const buttonNext = swiperElement.parentElement.querySelector('.wg-swiper-button-next')
      const buttonPrev = swiperElement.parentElement.querySelector('.wg-swiper-button-prev')
      // eslint-disable-next-line no-undef, no-new
      new Swiper(swiperElement, {
          loop: true,
          autoHeight: true,
          slidesPerView: 1,
          allowTouchMove: false,
          navigation: {
            nextEl: buttonNext,
            prevEl: buttonPrev
          }
        })
    })

    testimonialsSliderContainer.forEach(slide => {
      const swipperId = `#${slide.getAttribute('id')}`
      const swiperElement = document.querySelector(swipperId)
      const swiperPagination = swiperElement.closest('.testimonials').querySelector('.swiper-pagination')
      const buttonNext = swiperElement.closest('.testimonials').querySelector('.swiper-button-next')
      const buttonPrev = swiperElement.closest('.testimonials').querySelector('.swiper-button-prev')

      const {
        swiperLoop,
        swiperAutoHeight,
        swiperShowArrows,
        swiperSlidesPerViewDesktop,
        swiperSlidesPerViewTablet,
        swiperSlidesPerViewMobile,
        swiperShowPagination
      } = swiperElement.dataset

      const swiperOptions = {
        loop: swiperLoop === 'true',
        autoHeight: swiperAutoHeight === 'true',
        navigation: swiperShowArrows === 'true' ? {
            nextEl: buttonNext,
            prevEl: buttonPrev
          } : false,
        pagination: swiperShowPagination === 'true' ? {
            el: swiperPagination,
            type: 'bullets',
            clickable: true
          } : false,
        slidesPerView: +swiperSlidesPerViewDesktop,
        spaceBetween: 20,
        breakpoints: {
            320: {
                slidesPerView: +swiperSlidesPerViewMobile
              },
            768: {
                slidesPerView: +swiperSlidesPerViewTablet
            },
            1024: {
                slidesPerView: +swiperSlidesPerViewDesktop
            }
        }
      }

      // eslint-disable-next-line no-undef, no-new
      new Swiper(swiperElement, swiperOptions)
    })
  }